<template>
  <v-container class="px-1">
    <v-form ref="extratoFilterForm">
      <v-row  class="px-0">
        <v-col class="pt-0 pb-0 px-2" cols="12" sm="6" md="2">
          <label>Data de faturamento de</label>
          <v-menu
            ref="dtI"
            v-model="dtI"
            :close-on-content-click="true"
            transition="scale-transition"
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="dateIFormatted"
                dense
                v-mask="'##/##/####'"
                format="DD/MM/YYYY"
                placeholder="DD/MM/YYYY"
                label
                outlined
                v-bind="attrs"
                v-on="on"
                append-icon="mdi-calendar-blank"
                @blur="dateI = parseDate(dateIFormatted)"
                :rules="[formRules.requiredField, formRules.typeDateFormated]"
              ></v-text-field>
            </template>
            <v-date-picker color="primary"  v-model="dateI" no-title scrollable></v-date-picker>
          </v-menu>
        </v-col>
        <v-col class="pt-0 pb-0 px-2" cols="12" sm="6" md="2">
          <label>até</label>
          <v-menu
            ref="dtF"
            v-model="dtF"
            :close-on-content-click="true"
            transition="scale-transition"
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="dateFFormatted"
                v-mask="'##/##/####'"
                format="DD/MM/YYYY"
                placeholder="DD/MM/YYYY"
                label
                dense
                outlined
                v-bind="attrs"
                v-on="on"
                append-icon="mdi-calendar-blank"
                @blur="dateF = parseDate(dateFFormatted)"
                :rules="[formRules.requiredField, formRules.typeDateFormated]"
              ></v-text-field>
            </template>
            <v-date-picker color="primary"  v-model="dateF" no-title scrollable></v-date-picker>
          </v-menu>
        </v-col>
        <v-col class="pt-0 pb-0 px-2" cols="2">
            <label>Pesquisar por</label>
            <v-select
                v-model="formData.tipo_busca"
                :items="typeSearchList"
                item-value="id"
                item-text="descricao"
                :menu-props="{ bottom: true, offsetY: true }"
                flat
                solo
                dense
                outlined
                @change="formData.nota_fiscal = null; formData.protocolo = null; formData.num_lote = null;"
            ></v-select>
          </v-col>
          <v-col class="pt-5 pb-0 px-2" cols="3">
            <v-text-field
                v-model="formData[formData.tipo_busca]"
                prepend-inner-icon="mdi-magnify"
                :placeholder="labelBuscaGenerica[formData.tipo_busca]"
                single-line
                outlined
                dense
                hide-details
                :disabled="!formData.tipo_busca"
            ></v-text-field>
          </v-col>
         <v-col class="pt-0 pb-0 px-2" cols="12" sm="6" md="3">
           <v-checkbox
           style="font-size: 14px !important"
            class="pa-0 ma-0 pt-4"
            small
            v-model="formData.complementar"
            label="Apenas lotes complementares"
            hide-details
          ></v-checkbox>
         </v-col>
      </v-row>
      <v-row>
        <v-col class="pt-0 pb-0 px-2" cols="12" sm="6" md="2">
          <label>Prestador</label>
          <v-autocomplete
            v-model="formData.prestador_ids"
            :items="prestadoresFilter"
            item-value="id"
            item-text="prest_nome"
            label="Selecione"
            multiple
            chips
            outlined
            flat
            solo
            dense
            filled
            :disabled="prestadoresFilter.length == 1"
            :search-input.sync="searchInput"
          >
            <template v-slot:item="data">
              <v-list-item
                @click="toggleAutocomplete(data.item, 'prestador_ids')"
                :class="
                  formData.prestador_ids.includes(data.item.id)
                    ? 'primary--text v-list-item--active'
                    : ''
                "
              >
                <v-list-item-content>
                  <v-list-item-title>{{
                    data.item.prest_nome
                  }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <template v-slot:selection="data">
              <v-chip
                v-if="data.index < 2"
                small
                label
                class="ma-1"
                :style="
                  formData.prestador_ids.length > 1
                    ? 'max-width:30%'
                    : 'max-width:100%'
                "
                >{{ data.item.prest_nome }}</v-chip
              >
              <span v-if="data.index == 2" class="ml-2 grey--text caption">
                (+{{
                  formData.prestador_ids.length == 3
                    ? formData.prestador_ids.length - 2 + " outro"
                    : formData.prestador_ids.length - 2 + " outros"
                }})
              </span>
            </template>
          </v-autocomplete>
          <!-- <v-select
            v-model="formData.prestador_id"
            :items="prestadoresFilter"
            item-value="id"
            item-text="prest_nome"
            :menu-props="{ bottom: true, offsetY: true }"
            flat
            solo
            dense
            outlined
            @change="changePrestador()"
          ></v-select> -->
        </v-col>
        <v-col class="pt-0 pb-0 px-2" cols="12" sm="6" md="2">
          <label>Operadora</label>
          <v-autocomplete
            v-model="formData.operadora_ans_id"
            :items="operadorasFilter"
            item-value="id"
            item-text="oper_nome"
            label="Selecione"
            multiple
            chips
            outlined
            flat
            solo
            dense
            filled
            :search-input.sync="searchInput"
          >
            <template v-slot:item="data">
              <v-list-item
                @click="toggleAutocomplete(data.item, 'operadora_ans_id')"
                :class="
                  formData.operadora_ans_id.includes(data.item.id)
                    ? 'primary--text v-list-item--active'
                    : ''
                "
              >
                <v-list-item-content>
                  <v-list-item-title>{{
                    data.item.oper_nome
                  }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <template v-slot:selection="data">
              <v-chip
                v-if="data.index < 2"
                small
                label
                class="ma-1"
                :style="
                  formData.operadora_ans_id.length > 1
                    ? 'max-width:30%'
                    : 'max-width:100%'
                "
                >{{ data.item.oper_nome }}</v-chip
              >
              <span v-if="data.index == 2" class="ml-2 grey--text caption">
                (+{{
                  formData.operadora_ans_id.length == 3
                    ? formData.operadora_ans_id.length - 2 + " outro"
                    : formData.operadora_ans_id.length - 2 + " outros"
                }})
              </span>
            </template>
          </v-autocomplete>
          <!-- <v-select
            v-model="formData.operadora_ans_id"
            :items="operadorasFilter"
            item-value="id"
            item-text="oper_nome"
            :menu-props="{ bottom: true, offsetY: true }"
            flat
            solo
            dense
            outlined
          ></v-select> -->
        </v-col>
        <v-col class="pt-0 pb-0 px-2" cols="12" sm="6" md="2">
          <label>Responsável</label>
          <v-select
            v-model="formData.owner_id"
            :items="responsaveisFilter"
            item-value="Id"
            item-text="UserName"
            :menu-props="{ bottom: true, offsetY: true }"
            flat
            solo
            dense
            outlined
          ></v-select>
        </v-col>
        <v-col class="pt-0 pb-0 px-2" cols="12" sm="6" md="2">
          <label>Status do cronograma</label>
          <v-select
            v-model="formData.card_name"
            :items="statusFilter"
            item-value="id"
            item-text="descricao"
            :menu-props="{ bottom: true, offsetY: true }"
            flat
            solo
            dense
            outlined
          >
            <template v-slot:item="data">
              <template v-if="(typeof data.item !=='object')">
                <v-list-item-content v-text="data.item"></v-list-item-content>
              </template>
              <template v-else>
                <v-list-item-content>
                  <v-list-item-title v-html="data.item.descricao"></v-list-item-title>
                </v-list-item-content>
                <v-list-item-avatar size="20" :color="data.item.color" v-if="data.item.color">
                </v-list-item-avatar>
              </template>
            </template>
          </v-select>
        </v-col>
        <v-col class="pt-0 pb-0 px-2">
        <v-btn
          class="mt-5"
          height="32px"
          small
          depressed
          color="primary"
          @click="sendFilter()"
        >Filtrar</v-btn>
        <v-btn
          class="mt-5 ml-4"
          height="31px"
          small
          depressed
          outlined
          color="primary"
          @click="clearFilters()"
        >Limpar Filtros</v-btn>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import { mask } from 'vue-the-mask'
import { mapState } from "vuex"
export default {
  directives: {
    mask
    },
  beforeCreate(){
    this.monName = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"]
  },
  data(){
    return {
      cookieFilter: null,
      prest: null,
      formData: {
        card_name: null,
        complementar: null,
        data_fim: null,
        data_inicio: null,
        modulo_operadora: "faturamento",
        nota_fiscal: null,/* novo filtro */
        num_lote: null, /* novo filtro */
        operadora_ans_id: [],
        owner_id: null,
        prestador_id: null,
        prestador_ids: [],
        protocolo: null, /* novo filtro */
        tipo_busca: null
      },
      dateF: null,
      dateFFormatted: null,
      dateI:null,
      dateIFormatted: null,
      dtI: false,
      dtF: false,
      prestadoresFilter:[],
      operadorasFilter:[],
      responsaveisFilter: [],
      labelBuscaGenerica:{
        nota_fiscal: 'Número da nota fiscal',
        protocolo: 'Número do protocolo',
        num_lote: 'Número do lote'
      },
      monName: [],
      typeSearchList: [
        {id: null, descricao: 'Selecione'},
        {id: 'nota_fiscal', descricao: 'Nota fiscal'},
        {id: 'protocolo', descricao: 'Protocolo'},
        {id: 'num_lote', descricao: 'Nº do lote'}
      ],
      tipo_busca: null,
      searchInput: null
    }
  },
  computed: {
    ...mapState({
      formRules: state => state.formRules
    }),
  },  
  methods: {
    sendFilter(){
      if(this.$refs.extratoFilterForm.validate()){
        this.updateFilter(this.formData, true)
      }
    },
    clearFilters(){
      this.dateFFormatted = null;
      this.dateIFormatted = null;
      this.formData.nota_fiscal = null;
      this.formData.num_lote = null;
      this.formData.protocolo = null;
      this.formData.tipo_busca = null;
      this.formData.data_fim = null;
      this.formData.data_inicio = null;
      this.formData.card_name = null;
      this.formData.owner_id = null;
      this.formData.operadora_ans_id = [];
      this.formData.modulo_operadora = "faturamento"
      if (this.prestadoresFilter.length>1) {
        this.formData.prestador_ids = [];
      }
      this.updateFilter(this.formData, false)
    },
    formUpdate(){
      this.$store.dispatch('faturamento/getExtratoFilter', "extratoSIADFilter")
    .then( resp => {
      let flt = resp? resp : {}
      this.formData.modulo_operadora = "faturamento"
      if(flt){
        this.dateFFormatted = this.formatDate(flt.data_fim)
        this.dateIFormatted = this.formatDate(flt.data_inicio)
        this.formData = Object.assign(this.formData, flt)
        let {modulo_operadora, operadora_ans_id, owner_id, prestador_ids } = this.formData
        let payload = {
          owner_id,
          operadora_ans_id,
          modulo_operadora,
          prestador_id: null,
          prestador_ids
        }               
        if(this.formData.prestador_ids.length) {
          if (!this.controlResponsavel) {
            this.getResponsaveis(payload)
            this.formData.owner_id = flt.owner_id
          }
          this.getOperadoras(this.formData)
        }
      } else {
        let {modulo_operadora, operadora_ans_id, owner_id, prestador_ids } = this.formData
        let payload = {
          owner_id,
          operadora_ans_id,
          modulo_operadora,
          prestador_id: null,
          prestador_ids
        }               
        this.getOperadoras(this.formData)
        this.getResponsaveis(payload)
      }
      //this.prestadorId(this.formData.prestador_ids.length>0?this.formData.prestador_ids[0]: null)
      this.updateFilter(this.formData, false)
      })
    },
    toggleAutocomplete(item, campo) {
      this.searchInput = null
      let index = this.formData[campo].indexOf(item.id);
      //  index > -1  está excluindo o item
      if (index > -1) {
        this.formData[campo].splice(index, 1);
      } else {
        //  index < 0  está adicionando o item
        this.formData[campo].push(item.id);
      }
      this.$nextTick();
      return;
    },
  },
  props: {
    controlResponsavel: Boolean,
    filter: Object,
    formatDate: Function,
    updateFilter: Function,
    getOperadoras: Function,
    getResponsaveis: Function,
    operadoras: Array,
    parseDate: Function,
    prestadores: Array,
    responsaveis: Array,
    userData: Object,
    //prestadorId: Function,
    statusFilter: Array
  },
  mounted() {
    this.$store.dispatch('faturamento/getFilter', "extratoSIADFilter").then(resp=>{
      
      let flt = resp? resp : this.filter 
      console.log("extratoSIADFilter", flt)
      if(flt){
        this.dateFFormatted = this.formatDate(flt.data_fim)
        this.dateIFormatted = this.formatDate(flt.data_inicio)
        this.formData = Object.assign(this.formData, flt)
        let {grupo_economico, prestador_ids, modulo_operadora} = flt;
        let payload = {
          grupo_economico,
          sem_bloqueados: true,
          prestador_ids,
          modulo: modulo_operadora,
          modulo_operadora
        }
        this.getResponsaveis(payload)
        this.getOperadoras(payload)
        this.formData.num_lote = flt.num_lote;
        this.formData.nota_fiscal = flt.nota_fiscal;
        this.formData.protocolo = flt.protocolo;
        this.formData.typeSearch = flt.typeSearch;
        
      } else {
        this.clearFilters()
        let {grupo_economico, prestador_ids, modulo_operadora}  = this.formData
        this.formData.owner_id = null
        this.formData.operadora_ans_id = []
        this.formData.modulo_operadora = "faturamento"
        this.getOperadoras({modulo_operadora})
        let payload = {
          grupo_economico,
          sem_bloqueados: true,
          prestador_ids,
          modulo: modulo_operadora,
          modulo_operadora
        }
        this.getResponsaveis(payload)
      }
      
      this.updateFilter(flt, false)
    })
  },
  watch: {
    dateF(val){
      if (!val) {
        this.dateFFormatted = null
      } else {
        if (!!this.dateI && Date.parse(this.dateI) > Date.parse(val)){
          this.dateI = val
        }
        this.dateFFormatted = this.formatDate(val)
      }
    },
    dateFFormatted(val){
      this.formData.data_fim = this.parseDate(val)
    },
    dateI(val){
      if (!val) {
        this.dateIFormatted = null
      } else {
        if (!!this.dateF && Date.parse(this.dateF) < Date.parse(val)){
          this.dateF = val
        }
        this.dateIFormatted = this.formatDate(val)
      }
    },
    dateIFormatted(val){
      this.formData.data_inicio = this.parseDate(val)
    },
    prestadores:{
      deep: true,
      handler(val){
        this.prestadoresFilter = Array.from(val)
        // if(this.prestadoresFilter.length==1){
        //   this.formData.prestador_id = this.prestadores[0].id
        // } else {
          this.prestadoresFilter.unshift({id: null, prest_nome: "Selecione"})
        // }
      }
    },
    operadoras:{
      deep: true,
      handler(val){
        this.operadorasFilter = Array.from(val)
        this.operadorasFilter.unshift({id: null, oper_nome: "Selecione"})
      }
    },
    responsaveis:{
      deep: true,
      handler(val){
        this.responsaveisFilter = Array.from(val)
        this.responsaveisFilter.unshift({Id: null, UserName: "Selecione"})
      }
    }
  },
};
</script>
